import React, { useEffect } from "react";
import SmallLoader from "@/components/loaders/SmallLoader";
import { AnimatePresence, motion } from "framer-motion";
import Lottie from "react-lottie";
import animationData from "../../../assets/LottiFiles/CrossAnimation.json";

interface RemoveConfirmationProps {
  removeData: {
    status: boolean;
    remove: () => void;
  };
  setRemoveData: React.Dispatch<
    React.SetStateAction<{
      status: boolean;
      remove: () => void;
    }>
  >;
  isLoading: boolean;
}

const defaultOptions = {
  loop: false,
  Autoplay: true,
  animationData: animationData,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const RemoveConfirmation: React.FC<RemoveConfirmationProps> = ({
  removeData,
  setRemoveData,
  isLoading,
}) => {
  return (
    // <AnimatePresence>
    <div className="createbot-modal">
      <motion.div
        initial={{ scale: 0.9, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0.9, opacity: 0 }}
        className="flex-cnt mx-4 w-[680px] flex-col rounded-[10px] bg-[linear-gradient(180deg,_#FB5F66_-51.8%,_#FFFFFF_70.59%)] p-[40px]"
      >
        <Lottie options={defaultOptions} height={150} width={150} />
        <h2 className="mb-[10px] text-[18px] font-medium text-text-clr">
          You are about to remove this file
        </h2>
        <p className="mb-[30px] text-[14px] text-[#444444CC]">
          Are you sure want to remove this file? This action cannot be undone.
        </p>

        <div className="flex justify-end gap-4">
          <motion.button
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.5 },
            }}
            whileTap={{ scale: 0.9 }}
            onClick={() => setRemoveData({ ...removeData, status: false })}
            disabled={isLoading}
            className="h-[45px] w-[170px] rounded-[6px] border border-primary-clr text-[14px] text-primary-clr"
          >
            Cancel
          </motion.button>
          <motion.button
            whileHover={{
              scale: 1.1,
              transition: { duration: 0.5 },
            }}
            whileTap={{ scale: 0.9 }}
            onClick={removeData.remove}
            disabled={isLoading}
            className="w-[170px] rounded-[6px] border border-primary-clr bg-primary-clr text-[14px] text-white"
          >
            {isLoading ? " Deleting..." : "Delete"}
          </motion.button>
        </div>
      </motion.div>
    </div>
    // </AnimatePresence>
  );
};

export default RemoveConfirmation;
